import React from "react";
import clsx from "clsx";
import { ThumbUpIcon } from "~/components/icons/thumb-up";
import { NOT_SURE, THUMBS_DOWN } from "~/constants/globals";
import { useRoutePrefix } from "~/hooks/useRoutePrefix";
import * as styles from "./index.module.scss";

export function QuestionCard({
  imageSrc,
  imageAltText = "",
  label,
  sublabel = "",
  value,
  disabled = false,
  index,
  onClick,
}) {
  const { APP_PROXY_ROOT } = useRoutePrefix();
  const hideSvg = value === NOT_SURE ? styles.hideSvg : "";
  const thumbDown = value === THUMBS_DOWN ? styles.thumbDown : "";
  const largeDescriptionArea = !sublabel ? styles.largeDescriptionArea : "";
  const cardDisabled = disabled ? styles.cardDisabled : "";

  return (
    <button
      type="button"
      data-testid="quiz-v2-question-card"
      className={clsx(styles.card, cardDisabled)}
      onClick={() => {
        onClick(index);
      }}
    >
      <div className={clsx(styles.imageContent, hideSvg, thumbDown)}>
        <ThumbUpIcon size={22} color="#424242" />
        <img
          src={imageSrc?.startsWith("http") ? imageSrc : `${APP_PROXY_ROOT}/assets${imageSrc}`}
          alt={imageAltText || label}
        />
      </div>
      <div className={clsx(styles.description, largeDescriptionArea)}>
        <p>{label}</p>
        {sublabel && <p>{sublabel}</p>}
      </div>
    </button>
  );
}
